export default "__VITE_ASSET__D7A9IRrD__"